import { render, staticRenderFns } from "./form_row.vue?vue&type=template&id=851cf076&scoped=true&lang=pug"
import script from "./form_row.vue?vue&type=script&lang=js"
export * from "./form_row.vue?vue&type=script&lang=js"
import style0 from "./form_row.vue?vue&type=style&index=0&id=851cf076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851cf076",
  null
  
)

export default component.exports